
    import { Component, Prop, Vue } from 'vue-property-decorator';
    import VueI18n from 'vue-i18n';

    @Component
    export default class TooltipWrapper extends Vue {
        @Prop({ type: String as () => VueI18n.TranslateResult, default: '' }) readonly tooltip?: string;
        @Prop({ type: Boolean, default: true }) readonly condition?: string;
    }
